<div class="newsletter-body pt-5 mt-5">
    <router-outlet></router-outlet>
</div>
